import { Fetch } from 'lib/Fetch';

function fromApiResponseToToken({ data }) {
  const { token, expirationDate } = data.sessionItem;
  return { token, expirationDate };
}

export function usePortalAuthenticate() {
  return new Fetch()
    .url('/portal/portal')
    .method('post')
    .data({
      wholesalerId: '17f4ae46-e09f-42ed-85fa-1f1b22f8e7e2',
      wholesalerName: 'bloom',
      publicKey: '69C5973C32ABFF4781B3939ABC493',
    })
    .send()
    .then(fromApiResponseToToken);
}
